import { AllReportsListQuery, Report } from '@/__generated__/graphql';
import Grid from '@mui/material/Grid2';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { ReportCard } from './ReportCard';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { abyssColors } from '@/theme/colors';
import { NoReportFound } from '../shared/NoReportFound';

type Props = {
  reports: AllReportsListQuery['allReports'];
  label: string;
};
export const ReportListingAccordian = ({ reports, label }: Props) => {
  return (
    <Accordion sx={{ boxShadow: 'none', pt: 1, pb: 1 }} defaultExpanded>
      <AccordionSummary
        aria-controls={`${label}-content`}
        id={`${label}-header`}
        sx={{
          mb: 1,
          flexDirection: 'row-reverse',
          '& .MuiAccordionSummary-expandIconWrapper': {
            transform: 'rotate(-90deg)',
            transition: 'transform 0.2s ease-in-out',
            '&.Mui-expanded': {
              transform: 'rotate(0deg)',
            },
          },
          '& .MuiSvgIcon-root': {
            color: abyssColors.primary[500],
          },
        }}
        expandIcon={<ExpandMoreIcon sx={{ mr: 1 }} />}
      >
        <Typography variant="h6" fontWeight={'bold'}>
          {label}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container rowSpacing={3} columnSpacing={4} paddingX={1}>
          {reports.length === 0 ? (
            <Grid size={{ xs: 12 }} display="flex" justifyContent="center" alignItems="center">
              <NoReportFound />
            </Grid>
          ) : (
            <>
              {reports.map((report) => (
                <Grid key={report?.id} size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}>
                  <ReportCard report={report as Report} />
                </Grid>
              ))}
            </>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
